import { render, staticRenderFns } from "./pageDes.vue?vue&type=template&id=7bad2533&scoped=true"
import script from "./pageDes.vue?vue&type=script&lang=js"
export * from "./pageDes.vue?vue&type=script&lang=js"
import style0 from "./pageDes.vue?vue&type=style&index=0&id=7bad2533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bad2533",
  null
  
)

export default component.exports